import { useCallback } from 'react';
import TapFeature from '@alltrails/amplitude/enums/TapFeature';
import logTrailCardClicked from '@alltrails/amplitude/events/logTrailCardClicked';
import { getUrlFromSlug } from '@alltrails/cards/utils/cardLinks';
import usePublicBaseUrl from '@alltrails/context/hooks/usePublicBaseUrl';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import Link from '@alltrails/denali/components/Link';
import { COLOR_NEUTRAL_50 } from '@alltrails/denali/tokens';
import ShowMoreText from '@alltrails/layout/components/ShowMoreText/ShowMoreText';
import { useAppSelector } from '@/utils/redux';
import styles from './TopResults.module.scss';

type Props = {
  trailId: number;
  trailSlug: string;
  trailName: string;
  className: string;
  description?: string;
};

const TrailCardShowMoreText = ({ trailId, trailSlug, trailName, className, description }: Props) => {
  const languageRegionCode = useLanguageRegionCode();
  const publicBaseUrl = usePublicBaseUrl();
  const activeTrails = useAppSelector(state => state.map.activeTrails);
  const cardHoveredResult = activeTrails?.[0];
  const href = getUrlFromSlug(`/${trailSlug}`, publicBaseUrl, languageRegionCode);

  const handleTrailClick = useCallback(
    (tapFeature: TapFeature) => {
      logTrailCardClicked({
        trail_id: String(trailId),
        card_location: 'seo',
        detailed_card_location: 'highlights carousel',
        tap_feature: tapFeature
      });
    },
    [trailId]
  );

  return (
    <Link href={href} target="_blank" className={styles.resultStatsLink} onClick={() => handleTrailClick('more link')} title={trailName}>
      <ShowMoreText
        text={description}
        maxLines={3}
        className={className}
        preventExpansion
        useShortText
        showMoreBackgroundColor={String(cardHoveredResult?.ID) === String(trailId) ? COLOR_NEUTRAL_50 : undefined}
      />
    </Link>
  );
};

export default TrailCardShowMoreText;
